import { zeroDialogStyles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';

// Implementing some styling for the delete dialog in the Company Management.
// Zero Dialog doesnt seem to be used anywhere else in the system atm

export const customDialogStyles: ElementStyles = css`
  ${zeroDialogStyles}

  .bottom zero-button:first-of-type {
    margin-left: 10px;
    padding: 6px 10px;
    background: rgba(124, 144, 155, 0.5);
    border: 1px solid rgb(124, 144, 155);
  }

  .bottom zero-button:last-of-type {
    margin-left: 10px;
    padding: 6px 10px;
    background: linear-gradient(90deg, rgb(94, 141, 76) 0%, rgb(22, 122, 88) 100%);
    border: 1px solid #a9ff78;
  }
`;
